import { PAGE_RESERVATION_LINKS, PAGE_ONLINE_ORDERING, PAGE_MENUS } from './UriConstants';

export type RestaurantProfileSidebarItem = {
  id: string;
  label: string;
  path: string;
};

export const RESTAURANT_PROFILE_SIDEBAR_ITEMS: RestaurantProfileSidebarItem[] = [
  {
    id: 'basic-information',
    label: 'BASIC INFORMATION',
    path: '/basic-information'
  },
  {
    id: 'address',
    label: 'ADDRESS',
    path: '/address'
  },
  {
    id: 'hours',
    label: 'HOURS',
    path: '/hours'
  },
  {
    id: 'reservations-ordering',
    label: 'RESERVATIONS',
    path: `/${PAGE_RESERVATION_LINKS}`
  },
  {
    id: 'online-ordering',
    label: 'ONLINE ORDERING',
    path: `/${PAGE_ONLINE_ORDERING}`
  },
  {
    id: 'menus',
    label: 'MENUS',
    path: `/${PAGE_MENUS}`
  }
];
